import React from "react";
import KeepAliveRouteOutlet from "keepalive-for-react-router";

/**
 * 只缓存 /home：从列表离开再返回时列表不刷新、滚动位置恢复。
 */
function KeepAliveLayout() {
  return (
    <KeepAliveRouteOutlet
      include={["/home"]}
      max={10}
    />
  );
}

export default KeepAliveLayout;
